import BaseFormPage from "../../../base/BaseFormPage.js";
import {
  deleteObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object/index.js";
import withRouter from "../../../withRouter.js";
import dialog from "../../../components/Modal/dialog.js";
import FullPageLoader from "../../../components/FullPageLoader/index.js";
import DiscardDialog from "../../../components/DiscardDialog/index.js";
import BankFormPagePresenter from "./BankFormPagePresenter.js";
import PageHeader from "../../../components/PageHeader/index.js";
import { InfiniteScroll } from "../../../nq-component";
import CustomConfirmation from "../../../components/CustomConfirmation/index.js";
import FormFactory from "../../../components/FormFactory/index.js";

class BankFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
    this.presenter = new BankFormPagePresenter(
      this,
      getObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "banks";
  }

  onClose() {
    dialog.close();
  }

  onDiscardConfirm() {
    dialog.close();
    this.navigateBack();
  }

  discardModal() {
    dialog.fire({
      html: <DiscardDialog onConfirm={this.onDiscardConfirm.bind(this)} />,
      footer: false,
    });
  }

  render() {
    const { regions, provinces, progress, object } = this.state;
    const user = this.getCurrentUser();
    const isAdmin = this.isAdmin();
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();

    console.log("hasActualChanges", this.hasActualChanges());
    return (
      <>
        <InfiniteScroll className={"p-3 p-xl-4 overflow-auto"}>
          <div className="d-flex flex-column gap-4">
            {!progress ? (
              <>
                {/* Header Section */}
                <PageHeader
                  breadcrumb={[
                    { label: "Home", path: "/" },
                    { label: "Bank Accounts", path: "/bank-accounts" },
                    {
                      label: object?.id
                        ? "Edit Bank Account"
                        : "Add Bank Account",
                    },
                  ]}
                  object={object}
                  list={false}
                  backButton
                  documentName={"Bank Account"}
                  description={`${object?.id ? "Update" : "Enter"} your bank account details`}
                />

                {/* Form Card */}
                <form
                  className="bg-white rounded-3 d-flex flex-column shadow-sm p-2 p-md-3 p-lg-4 gap-2"
                  style={{
                    border: "1px solid #e9ecef",
                  }}
                  onSubmit={this.onSubmitForm.bind(this)}
                >
                  <FormFactory
                    schema={schema}
                    schemas={schemas}
                    onChange={this.onChange.bind(this)}
                    object={object}
                  />

                  <div className="d-flex gap-2 mt-2 col-12">
                    <button
                      type="button"
                      className="btn btn-light fw-medium border px-3 flex-fill"
                      onClick={this.onClickBack.bind(this)}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary fw-medium px-3 flex-fill"
                      disabled={!this.hasActualChanges()}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </>
            ) : (
              ""
            )}

            {progress ? <FullPageLoader /> : ""}
          </div>
        </InfiniteScroll>

        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(BankFormPage);
